import { isBrowser } from "./infrastructure/ssg-utils"

export function isMobile() {
    if (!isBrowser()) return
    return window.document.body.clientWidth < 576
}

export function isIE() {
    if (!isBrowser()) return
    return navigator.userAgent.indexOf("MSIE ") > 0 || navigator.userAgent.indexOf("Trident") > 0
}

export function isSafari() {
    if (!isBrowser()) return
    return navigator.userAgent.toLowerCase().indexOf("safari") !== -1
}
